



export interface UserData {
    id: string,
    email: string,
    permissions: Record<string, Set<string>>,
}
export interface AuthData extends UserData {
    id: string,
    email: string,
    token: string,
    permissions: Record<string, Set<string>>,
    tokenExpiry: number
}


let authData: AuthData | undefined;

export const storeAuthData = (data?: AuthData): AuthData => {
    authData = data;
    return authData!;// I dont care about undefined
}

export const getToken = () => {
    return authData?.token;
}


export const getUserData = () => {
    if (authData) {
        const { token, tokenExpiry, ...userData } = authData;
        return userData;
    }
}
export default {
    storeAuthData,
    getToken,
    getUserData,

}